export const USER_ACTION_TYPE = {
  SET_CURRENT_USER: 'user/SET_CURRENT_USER',
};
